import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    vueDropzone: vue2Dropzone
  },

  methods: {
      dropzoneOptions(type, path, maxFile = 1) {
          var token = 'Bearer ' + localStorage.getItem('auth_token');
          return {
              dictDefaultMessage: `<span class='title'>${this.$t('upload', this.$session.get('locale'))}</span>` ,
              addRemoveLinks: true,
              dictRemoveFile: this.$t('A01234',this.$session.get('locale')),
              maxFiles: maxFile,
              acceptedFiles:'image/*',
              url: path,
              thumbnailMethod: 'contain',
              maxFilesize: 25,
              resizeMimeType: 'image/jpeg',
              resizeQuality: 0.9,
              headers: {  "Document-Type": type, "Authorization": token },              
          }
      },

      uploadCallback(file, res) {
          if (res.code == 200) {
              this.form.files.push(res.data.file_id);
          }
      },

      removedCallback(file, error, xhr) {

          let res = JSON.parse(file.xhr.response);
          const index = array.indexOf(res.data.fileName);
          if (index > -1) {
              this.form.files.splice(index, 1);
          }
          this.form.files = '';
      },
  },
}
